import React from 'react';
import {
  DialogContent,
  DialogTitle,
  Modal,
  ModalClose,
  ModalDialog,
} from '@mui/joy';
import FunctionDocumentation from '../../../components/functions/FunctionDocumentation';

const HelpModal = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog sx={{ maxWidth: 800, width: '80vw' }}>
        <ModalClose />
        <DialogTitle>Function Documentation</DialogTitle>
        <DialogContent>
          <FunctionDocumentation />
        </DialogContent>
      </ModalDialog>
    </Modal>
  );
};

export default HelpModal;
